export default function Dao() {
  return (
    <div>
      <div
        style={{
          maxWidth: 540,
          padding: 20,
          lineHeight: 1.3,
          paddingBottom: 100,
          margin: '10vh auto',
        }}
      >
        <h3>TileDAO</h3>
        <p>
          TileDAO exists to reinvest revenue from the Tiles primary sale back
          into the creators' economy. Because the supply of Tiles is virtually
          limitless, the sale may continue indefinitely. The goal in forming
          this DAO is to amass inspiration, ideas, and opinions from everyone
          who has bought into this project, in order to best determine how the
          funding should be put to use.
        </p>
        <p>Above all else, art is a pillar of community.</p>
        <h4>Funding</h4>
        <p>
          All revenue from Tile sales are sent to the TileDAO wallet, a{' '}
          <a
            href="https://juicebox.money/#/p/tiles"
            target="_blank"
            rel="noopener noreferrer"
          >
            Juicebox
          </a>{' '}
          treasury where all spending is programmable and transparent, and which
          rewards everyone who purchases Tiles with a balance of TILE ERC-20
          tokens proportional to the amount they've spent. As described in the{' '}
          <a href="/#/manifesto">manifesto</a>, it will be up to the community
          to decide how the treasury funds are put to use.
        </p>
        <p>
          To begin with, the only spending allocations made will be to support
          the Tile artist and the Juicebox platform. At any time, a portion of
          all unallocated funds can be claimed by TILE holders in exchange for
          burning TILE.
        </p>
        <h4>Community</h4>
        <p>
          The{' '}
          <a
            href="https://discord.gg/SqZA8dUFtY"
            target="_blank"
            rel="noreferrer"
          >
            TileDAO Discord
          </a>{' '}
          is open to anyone who owns at least 1 Tile. Get yours and come join
          us.
        </p>
      </div>
    </div>
  )
}
